import { useQuery } from '@tanstack/react-query';
import { getUserAuthData } from '@/data/auth';

/**
 * Cached hook for auth data - follows same pattern as useHomeProducts
 * Aggressive caching prevents redundant queries on page navigation
 */
export const useAuthData = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['auth-data', userId],
    queryFn: () => getUserAuthData(userId!),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,      // Fresh for 5 minutes
    gcTime: 30 * 60 * 1000,        // Keep in memory for 30 min
    refetchOnMount: false,          // Don't refetch if cached
    refetchOnWindowFocus: false,    // Don't refetch on tab focus
  });
};
